/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteConsequenceFromBehaviorBIPInfo$Params {
  Behavior_BIPInfo_ConsequenceID?: number;
}

export function DeleteConsequenceFromBehaviorBIPInfo(http: HttpClient, rootUrl: string, params?: DeleteConsequenceFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DeleteConsequenceFromBehaviorBIPInfo.PATH, 'post');
  if (params) {
    rb.query('Behavior_BIPInfo_ConsequenceID', params.Behavior_BIPInfo_ConsequenceID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DeleteConsequenceFromBehaviorBIPInfo.PATH = '/api/Staff/DeleteConsequenceFromBehaviorBIPInfo';
